import React, { createContext } from "react";
import { useTranslation } from "react-i18next";

import FilterByYear from "src/containers/FilterByYear/FilterByYear";
import useChangeYear from "src/containers/FilterByYear/useChangeYear/useChangeYear";
import DocumentsReportTable from "../../../containers/DocumentsReport/DocumentsReportTable";
import LoadingOverlay from "../../../containers/LoadingOverlay/LoadingOverlay";
import {
  LegalEntityQuickfilter,
  useLegalEntityQuickFilter,
} from "../../../containers/Quickfilters/LegalEntityQuickfilter";

import { LegalEntityOptionValue } from "../../../containers/Quickfilters/LegalEntityQuickfilter/interfaces";
import useAuthorization from "../../../custom-hooks/useAuthorization/useAuthorization";
import { CompanyLegalEntityDTO } from "../../../models/company-accounts/company-legal-entities";
import { NotAuthorizedPage } from "../../../reusable-components/NotAuthorizedPage/NotAuthorizedPage";
import { AUTHORIZATIONS } from "../../../utils/constants/authorization-constants";
import { DOCUMENTS_REPORTS } from "../../../utils/constants/constants";
import { FT_DPR } from "../../../utils/constants/filter-tables-constants";

interface Filter {
  legalEntity: {
    legalEntityOption: LegalEntityOptionValue | null;
    selectedLegalEntity: CompanyLegalEntityDTO | null;
    legalEntityQuickFilter: JSX.Element | null;
  };
  userIsClient: boolean;
}

export const MyTeamPayrollOutputDocumentsContext = createContext<Filter>({
  legalEntity: {
    legalEntityOption: null,
    selectedLegalEntity: null,
    legalEntityQuickFilter: null,
  },
  userIsClient: false,
});

const MyTeamPayrollOutputReport = () => {
  const { t } = useTranslation();
  const tRP = "pages.document_reports.payroll_output_report";

  const {
    legalEntitiesQuickFilter,
    setLegalEntitiesQuickFilter,
    selectedLegalEntity,
    legalEntityQFIsLoading,
    allLegalEntities,
  } = useLegalEntityQuickFilter();

  const { year, handleChangeYear } = useChangeYear();

  const hasAccess = useAuthorization([AUTHORIZATIONS.EmployeesAccess.ViewSalaryAndCompensationData]);

  return (
    <>
      {hasAccess ? (
        <MyTeamPayrollOutputDocumentsContext.Provider
          value={{
            legalEntity: {
              legalEntityOption: legalEntitiesQuickFilter.legalEntities,
              selectedLegalEntity,
              legalEntityQuickFilter: (
                <LegalEntityQuickfilter
                  quickFilters={legalEntitiesQuickFilter}
                  handleChangeQuickFilters={setLegalEntitiesQuickFilter}
                  allLegalEntitiesOption
                  allLegalEntities={allLegalEntities}
                />
              ),
            },
            userIsClient: true,
          }}
        >
          <LoadingOverlay loading={legalEntityQFIsLoading}>
            {!legalEntityQFIsLoading && (
              <DocumentsReportTable
                loadItemsPath="/GetEmployeeGroupDocumentsReport"
                filter={FT_DPR}
                documentReportId={DOCUMENTS_REPORTS.PAYROLL_OUTPUT_REPORT_ID}
                allReportsAlwaysOn={true}
                allowAuthorizations={[AUTHORIZATIONS.EmployeesAccess.ViewSalaryAndCompensationData]}
                legalEntityFilter={{ legalEntityOption: legalEntitiesQuickFilter.legalEntities, selectedLegalEntity }}
                quickFilters={
                  <>
                    <LegalEntityQuickfilter
                      quickFilters={legalEntitiesQuickFilter}
                      handleChangeQuickFilters={setLegalEntitiesQuickFilter}
                      allLegalEntitiesOption
                      allLegalEntities={allLegalEntities}
                    />
                    <FilterByYear
                      year={year}
                      handleChangeYear={handleChangeYear}
                      filterColor={"filter"}
                    />
                  </>
                }
                tableTitle={`${t(`${tRP}.tab_label`)}`}
                year={year}
                showPeriodTypeQF={false}
              />
            )}
          </LoadingOverlay>
        </MyTeamPayrollOutputDocumentsContext.Provider>
      ) : (
        <NotAuthorizedPage />
      )}
    </>
  );
};

export default MyTeamPayrollOutputReport;
